import { createRouterLinks } from "@/models/router";
import { RouteConfig } from "vue-router";
import { RCandidateGuide } from "./views/Guide/RCandidateGuide";
import { RCandidateServices } from "./views/Services/RCandidateServices";
import { RCandidateTasks } from "./views/Tasks/RCandidateTasks";
// import { RCandidateCopilot } from "./views/Copilot/RCandidateCopilot";

export const RCandidate: RouteConfig = {
  path: "",
  name: "Candidate",
  component: () =>
    import(
      /* webpackChunkName: "candidate" */
      "./VCandidate.vue"
    ),
  children: [
    RCandidateServices,
    RCandidateGuide,
    RCandidateTasks,
    // RCandidateCopilot,
  ],
};

export const candidateLinks = createRouterLinks(RCandidate);
